import { render, staticRenderFns } from "./processing_transactionsV2.vue?vue&type=template&id=2e65db01&"
import script from "./processing_transactionsV2.vue?vue&type=script&lang=js&"
export * from "./processing_transactionsV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports